import {
  GET_FILES,
  DELETE_FILES,
  DOWNLOAD_FILES,
  API_RESPONSE_ERROR,
  API_RESPONSE_SUCCESS,
} from './actionType';

// common success
export const FilesApiResponseSuccess = (actionType, data) => ({
  type: API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const FilesApiResponseError = (actionType, error) => ({
  type: API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const GetFiles = (id) => ({
  type: GET_FILES,
  payload: { id },
});

export const DownloadFiles = (path) => ({
  type: DOWNLOAD_FILES,
  payload: { path },
});

export const DeleteFiles = (path) => ({
  type: DELETE_FILES,
  payload: { path },
});
